import axios from 'axios'
import router from './router'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

apiClient.interceptors.response.use(
  response => {
    console.log('Response intercepted:', response);
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      const store = require('@/store').default;
      store.commit('logout');
      
      if (router.currentRoute.value.name !== 'Login') {
        router.push({ name: 'Login' });
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient
